import React, { useMemo } from 'react';
import ReactDonutChart from 'react-donut-chart';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DonutBox } from './styled';
import { Box } from '@mui/material';
import { millifyNumber } from '../../../utils/millify-number';

function DonutChart({ data, title, label, colorMapping = {} }) {
  const { t } = useTranslation();

  const reactDonutChartdata = useMemo(
    () =>
      data?.map((item) => ({
        ...item,
        label: t(label)
      })),
    [data, t]
  );

  const reactDonutChartBackgroundColor = Object.values(colorMapping);
  const reactDonutChartInnerRadius = 0.5;
  const reactDonutChartSelectedOffset = 0.03;

  const renderLegendElement = (item, index) => (
    <Box
      key={`legend-item-${index}`}
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        mt: '10px'
      }}
    >
      <Box
        sx={{
          width: '13px',
          height: '13px',
          borderRadius: '50%',
          bgcolor: item?.color
        }}
      />
      <Typography
        fontSize={12}
        fontWeight={300}
        letterSpacing="0.01438em"
        lineHeight="17px"
        sx={{ flexGrow: 1, ml: '7px' }}
      >
        {item?.label}
      </Typography>
      <Typography fontSize={14} fontWeight={500} lineHeight="17px" ml={'5px'}>
        {item?.value ? millifyNumber(item?.value) : null}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%',
        flexGrow: 1,
        '@media (max-width: 635px)': {
          flexWrap: 'wrap'
        }
      }}
    >
      <DonutBox sx={{ flexGrow: 1 }}>
        <ReactDonutChart
          clickToggle={false}
          colors={reactDonutChartBackgroundColor}
          data={reactDonutChartdata}
          height={193}
          innerRadius={reactDonutChartInnerRadius}
          legend={false}
          selectedOffset={reactDonutChartSelectedOffset}
          strokeColor="#FFFFFF"
          width={193}
        />
      </DonutBox>
      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
          height: 'auto',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {data?.map((item, index) => renderLegendElement(item, index))}
      </Box>
    </Box>
  );
}

DonutChart.propTypes = {
  data: PropTypes.any.isRequired,
  title: PropTypes.string,
  label: PropTypes.string,
  colorMapping: PropTypes.object
};

export { DonutChart };
